<template>
  <main class="page">
    <AppBack />
    <section class="section page__header">
        <h1 class="title">
          {{ isCreate ? "Создать договор" : "Редактировать договор" }}
        </h1>
    </section>

    <div class="form__bg">
      <Form v-model="initValue" @request="saveContractInfo" scrollWhenInvalid v-if="!isLoading">
      <section class="section">
        <h2 class="subtitle">Основная информация</h2>
        <div class="form__inputs">
          <VInput label="Номер документа" name="treaty_number" required :disabled="!roleAccessEdit">
            <Validation for="required">Поле обязательно</Validation>
          </VInput>
          <AppSelect
            title="Тип договора"
            name="type"
            :options="typeOptionList"
            required
            :disabled="!roleAccessEdit"
            placeholder="Не выбрано"
            >
            <Validation for="required">Поле обязательно</Validation>
          </AppSelect>
        </div>
        <h2 class="subtitle">Типовая форма договора</h2>
        <div class="form__inputs">
          <AppInputDate
            name="start_date"
            title="Дата заключения договора"
            required
            :disabled="!roleAccessEdit"
          >
            <Validation for="required">Поле обязательно</Validation>
          </AppInputDate>
          <AppInputDate
            name="term"
            title="Дата окончания договора"
            :disabled="!roleAccessEdit"
          />
          <AppSelect
            title="Статус договора"
            name="status"
            :options="statusOptionList"
            :disabled="!roleAccessEdit"
            placeholder="Не выбрано"
          >
            <Validation for="required">Поле обязательно</Validation>
          </AppSelect>
          <AppSelect
            name="project"
            title="Проект"
            :options="projectOptionList"
            :disabled="!roleAccessEdit"
            placeholder="Не выбрано"
            newItemFromSearch
            @search-changed="searchProject"
          />
          <AppSelect
            name="status_intex"
            title="Статус Промсервис"
            :options="statusIntexOptionList"
            :disabled="!roleAccessEdit"
            placeholder="Не выбрано"
          />
          <VInput label="Сумма" name="amount" :disabled="!roleAccessEdit" />
          <AppSelect
            name="stage"
            title="Стадия договора"
            required
            :options="stageOptionList"
            :disabled="!roleAccessEdit"
            placeholder="Не выбрано"
          >
            <Validation for="required">Поле обязательно</Validation>
          </AppSelect>
          <AppCheckbox
            class="form__checkbox-wrap"
            title="Без НДС"
            :checked="!initValue.with_nds"
            @toggle-check="initValue.with_nds = !initValue.with_nds"
          />
          <AppSelect
            name="worker"
            title="Ответственный сотрудник"
            required
            :options="assigneeOptionList"
            :disabled="!roleAccessEdit"
            placeholder="Не выбрано"
          >
            <Validation for="required">Поле обязательно</Validation>
          </AppSelect>
          <AppSelect
            title="Контрагент"
            name="contractor"
            required
            :options="contractorOptionList"
            :disabled="!roleAccessEdit"
            @search-changed="searchContractor"
            newItemFromSearch
            placeholder="Не выбрано"
          >
            <Validation for="required">Поле обязательно</Validation>
          </AppSelect>
        </div>
        <AppInputFile
          title="Прикрепить файл"
          :value="contract.files"
          @value-changed="setContractFile"
          name="documents"
          @delete-file="deleteContractFile"
          :disabled="!roleAccessEdit"
        />
        <div class="form__inputs form__inputs_col-1">
          <VInput label="Дополнительная информация" type="textarea" name="info" :disabled="!roleAccessEdit"/>
        </div>
      </section>

      <section class="section" style="margin-top: 12px">
        <div class="page__buttons">
          <div class="page__item">
            <AppButton
              :title="isCreate ? 'Создать' : 'Сохранить'"
              type="main"
              :disabled="!roleAccessEdit"
            />
          </div>
          <div class="page__item">
            <AppButton title="Отмена" type="alt" @click.prevent.native="leavePage" />
          </div>
        </div>
      </section>
    </Form>
    </div>

    <ThePagePreloader v-if="isLoading" />
  </main>
</template>

<script>
import AppBack from '../../components/page/AppBack'
import AppButton from '../../components/page/button/AppButton'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppSelect from '@/components/page/input/AppSelect'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppInputFile from '@/components/page/input/AppInputFile'
import Form from '@/components/page/Form/Form.vue'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import Validation from '@/components/page/Form/Validation.vue'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'

import { currentDateTime } from '@/utils/utils'
import axios from '@/utils/axios.js'
import { config, url } from '@/store/index'

export default {
  name: 'ContractUpdate',
  data () {
    return {
      isLoading: false,
      initValue: {
        start_date: currentDateTime(),
        term: currentDateTime(),
        // НДС
        with_nds: true
      }
    }
  },
  components: {
    AppBack,
    AppButton,
    AppCheckbox,
    AppInputDate,
    AppInputFile,
    AppSelect,
    Form,
    ThePagePreloader,
    Validation,
    VInput
  },
  computed: {
    contract () {
      return this.$store.getters.getContractForUpdate
    },
    validation () {
      return this.$store.getters.getContractUpdateValidation
    },
    statusOptionList () {
      return this.$store.getters.getContractStatusList
    },
    statusIntexOptionList () {
      return this.$store.getters.getContractStatusIntexList
    },
    projectOptionList () {
      return this.$store.getters.getContractProjectList
    },
    assigneeOptionList () {
      return this.$store.getters.getContractAssigneeList
    },
    typeOptionList () {
      return this.$store.getters.getContractTypeList
    },
    stageOptionList () {
      return this.$store.getters.getContractStageList
    },
    contractorOptionList () {
      return this.$store.getters.getContractContractorList
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContracts.actions.update
    },
    isCreate () {
      return this.$route.params.id === 'create'
    }
  },
  methods: {
    saveContractInfo (data) {
      const actionType = this.$router.history.current.params.id
      const contractData = { ...data, actionType }
      console.log('contractData', contractData)
      this.$store.dispatch('contractUpdateSaveInfo', contractData)
    },
    setContractTypeList (type) {
      this.$store.dispatch('contractUpdateSetType', type)
    },
    setContractFile (value) {
      this.$store.commit('SET_CONTRACT_UPDATE_FILES', value)
    },
    deleteContractFile (value) {
      this.$store.commit('DELETE_CONTRACT_UPDATE_FILE', value)
    },
    leavePage () {
      this.$router.push({ name: 'ContractList' })
    },
    searchContractor (value) {
      this.$store.dispatch('getSearchContractContractorsList', value)
    },
    searchProject (value) {
      this.$store.dispatch('getSearchContractProjectList', value)
    },
    getContractUpdateInfo () {
      this.isLoading = true
      const expands = 'expand=project,status,stage,type,partner,worker,files'

      axios.get(`${url}/treaties/${this.$route.params.id}?${expands}`, config).then(response => {
        const data = response.data.data
        const status_intex = this.statusIntexOptionList.find(option => option.id === data.status_intex_id)

        let contractor = null
        let worker = null
        if (data.partner) {
          contractor = {
            name: data.partner?.long_name,
            id: data.partner?.id
          }
        }
        if (data.worker) {
          worker = {
            name: data.worker?.profile?.full_name,
            id: data.worker?.profile?.id
          }
        }

        console.log('data', data)
        this.initValue = {
          ...data,
          status_intex,
          worker,
          contractor
        }

        const files = data.files?.map(e => {
          return {
            name: e.file_name,
            size: e.file_size,
            url: e.url,
            type: e.content_type,
            id: e.id
          }
        }) || []
        this.setContractFile(files)
        this.isLoading = false
      }).catch(error => {
        console.log('ошибка получения списка документы', error)
      })
    }
  },
  mounted () {
    if (!this.isCreate) {
      this.getContractUpdateInfo()
    }
    this.$store.dispatch('getContractUsers')
    this.$store.dispatch('getContractAllOptions')
  },
  beforeDestroy () {
    this.$store.dispatch('setContractUpdateInitialState')
  }
}
</script>

<style lang="scss" scoped>
.page__item {
  margin-right: 40px;
}

.form__inputs_col-1 {
  margin-top: 20px;
}
</style>
